import React, { FC } from 'react'
import { Breadcrumb, Col, FlexboxGrid } from 'rsuite'
import LegacyAngleRightIcon from '@rsuite/icons/legacy/AngleRight'
import useTranslation from 'next-translate/useTranslation'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { ParentPointer } from '../../utils/types/misc'
import useUrls from '../../services/useUrls'
import { QueryParam } from '../../utils/constants'

import styles from '../../styles/ProductCatalog.module.less'

interface CategoryBreadcrumbProps {
  category: string
  breadcrumbs: Pick<ParentPointer, 'code' | 'label'>[]
  className?: string
  isSupplierShop?: boolean
}

const CategoryBreadcrumb: FC<CategoryBreadcrumbProps> = (
  {
    breadcrumbs,
    category,
    isSupplierShop = false,
    className = '',
  },
) => {
  const { urlT } = useUrls()
  const { t } = useTranslation('products')
  const { query } = useRouter()

  const searchQuery = query[QueryParam.search]
  const rootBreadcrumb = isSupplierShop ? t('All products') : t('Featured')

  const getCategoryURL = (id: string) => {
    let url = ''
    const parentCategoryId = breadcrumbs[0].code

    if (parentCategoryId === id) {
      url = id
    } else {
      url = `${parentCategoryId}/${id}`
    }

    return isSupplierShop
      ? `/supplier/${query.supplierCode}/category/${url}`
      : `/products/category/${url}`
  }

  return (
    <FlexboxGrid>
      <FlexboxGrid.Item
        as={Col}
        md={24}
        xs={16}
        className="padding-left-zero"
      >
        <Breadcrumb
          separator={<LegacyAngleRightIcon />}
          className={`${styles['category-breadcrumb']} ${className}`}
          maxItems={7}
        >
          <Breadcrumb.Item
            as={Link}
            href={urlT('/')}
            shallow
          >
            {rootBreadcrumb}
          </Breadcrumb.Item>
          {breadcrumbs.map((cat) => (
            category !== cat.code ? (
              <Breadcrumb.Item
                key={cat.code}
                as={Link}
                href={urlT(getCategoryURL(cat.code))}
                shallow
              >
                {cat.label}
              </Breadcrumb.Item>
            )
              : (
                <Breadcrumb.Item
                  active
                  key={cat.code}
                >
                  {cat.label}
                </Breadcrumb.Item>
              )
          ))}
          {searchQuery && (
            <Breadcrumb.Item active>{`"${searchQuery}"`}</Breadcrumb.Item>
          )}
        </Breadcrumb>
      </FlexboxGrid.Item>
    </FlexboxGrid>

  )
}

export default CategoryBreadcrumb
